// Wait for both DOM and GSAP to be ready
document.addEventListener('DOMContentLoaded', () => {
  // Check if GSAP is loaded
  if (typeof gsap === 'undefined') {
    console.error('GSAP is not loaded');
    return;
  }

  // Initialize social icons animation
  initSocialIcons();
  
  // Initialize wiggle effect
  initWiggle();
  
  // Force a reflow to ensure GSAP can properly animate elements
  document.body.offsetHeight;
});

function initSocialIcons() {
  // Wait for the DOM to be fully ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSocialIcons);
    return;
  }

  // Select all social icon links
  const icons = document.querySelectorAll('.social-icons .nav-link');
  if (icons.length === 0) return;
  
  // Gradient colors - using vibrant pastels
  const colors = [
    '#FF9BB4', // Pink
    '#FFB77D', // Orange
    '#FFE17E', // Yellow
    '#7FE0B5', // Green
    '#7ED8F7', // Blue
    '#B28AFF'  // Purple
  ];
  
  // Animation settings
  const colorDuration = 4; // Slightly slower for smoother blend
  const gradientSize = 200; // Size of the gradient

  // Create all background elements first
  icons.forEach(icon => {
    // Remove any existing background elements to prevent duplicates
    const existingBg = icon.querySelector('.icon-bg');
    if (existingBg) {
      icon.removeChild(existingBg);
    }
    
    // Create and append new background element
    const bg = document.createElement('div');
    bg.className = 'icon-bg';
    icon.insertBefore(bg, icon.firstChild);
    
    // Set initial styles
    Object.assign(bg.style, {
      position: 'absolute',
      top: '50%',
      left: '50%',
      width: '44px',
      height: '44px',
      margin: '-22px 0 0 -22px',
      borderRadius: '50%',
      backgroundColor: 'transparent',
      border: 'var(--border-width) solid var(--black)',
      boxShadow: 'var(--shadow)',
      pointerEvents: 'none',
      zIndex: '0',
      display: 'block',
      opacity: '0',
      transform: 'scale(0) translateZ(0)',
      transformOrigin: 'center center',
      overflow: 'hidden',
      willChange: 'transform, opacity'
    });
    
    // Force a reflow to ensure styles are applied
    bg.offsetHeight;
  });
  
  // Now set up the event listeners
  icons.forEach((icon, index) => {
    const bg = icon.querySelector('.icon-bg');
    if (!bg) return;
    
    let colorIndex = 0;
    let colorInterval;
    
    function startColorAnimation() {
      // Create a linear gradient element that cycles through colors
      const gradient = document.createElement('div');
      gradient.style.cssText = `
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background: linear-gradient(
          135deg,
          ${colors[0]} 0%,
          ${colors[1]} 20%,
          ${colors[2]} 40%,
          ${colors[3]} 60%,
          ${colors[4]} 80%,
          ${colors[5]} 100%
        );
        background-size: 400% 400%;
        z-index: 0;
        animation: gradientShift 4s ease infinite;
      `;
      
      // Add keyframes for the gradient animation
      const style = document.createElement('style');
      style.textContent = `
        @keyframes gradientShift {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `;
      document.head.appendChild(style);
      
      // Add gradient element inside the background
      bg.innerHTML = '';
      bg.appendChild(gradient);
      
      // Animate the rotation
      const tl = gsap.timeline({
        repeat: -1,
        onUpdate: function() {
          if (!icon.matches(':hover')) {
            tl.pause(0);
          }
        }
      });
      
      tl.to(gradient, {
        rotation: 360,
        duration: colorDuration,
        ease: 'linear',
        transformOrigin: 'center'
      });
      
      // Store the timeline for cleanup
      icon._gradientTl = tl;
    }
    
    function stopColorAnimation() {
      // Kill any running gradient timeline
      if (icon._gradientTl) {
        icon._gradientTl.kill();
        delete icon._gradientTl;
      }
    }
    
    // Hover in
    icon.addEventListener('mouseenter', () => {
      // Kill any running animations
      gsap.killTweensOf(bg);
      gsap.killTweensOf(icon);
      
      // Show and animate in
      gsap.set(bg, { 
        display: 'block',
        opacity: 1,
        scale: 0.01,
        transformOrigin: 'center center'
      });
      
      // Bounce in animation
      gsap.timeline()
        .to(bg, {
          scale: 1.2,
          duration: 0.4,
          ease: 'back.out(2.5)'
        })
        .to(bg, {
          scale: 1,
          duration: 0.6,
          ease: 'elastic.out(1, 0.5)'
        }, '-=0.3');
      
      // Start the gradient wave
      stopColorAnimation();
      startColorAnimation();
      
      // Add rotation effect
      gsap.to(icon, {
        rotation: 5,
        duration: 0.3,
        ease: 'sine.out',
        yoyo: true,
        repeat: 1
      });
      
      // Add wobble effect
      gsap.to(bg, {
        rotation: -3,
        duration: 1.5,
        yoyo: true,
        repeat: -1,
        ease: 'sine.inOut'
      });
    });
    
    // Hover out
    icon.addEventListener('mouseleave', () => {
      // Stop color cycling
      stopColorAnimation();
      
      // Kill all animations
      gsap.killTweensOf(bg);
      gsap.killTweensOf(icon);
      
      // Animate out
      gsap.timeline({
        onComplete: () => gsap.set(bg, { clearProps: 'all' })
      })
      .to(bg, {
        scale: 0.9,
        opacity: 0,
        duration: 0.15,
        ease: 'power2.in'
      })
      .set(bg, { display: 'none' }, 0.15);
      
      // Reset rotation
      gsap.set(icon, { rotation: 0 });
    });
  });
}

function initWiggle() {
  const elements = document.querySelectorAll('.btn-wiggle, .wiggle-on-hover');
  
  elements.forEach(el => {
    el.addEventListener('mouseenter', function() {
      gsap.to(el, {
        rotate: '5deg',
        duration: 0.1,
        yoyo: true,
        repeat: 1,
        ease: 'sine.inOut'
      });
    });
  });
}

// Make functions available globally
window.WiggleTheme = {
  initSocialIcons: initSocialIcons,
  initWiggle: initWiggle
};
